<div class="card-holder">
  <h3 class="card-title">Twoja karta</h3>
  @if (card) {
    <div class="card-content">
      <div class="qr-code">
        <!-- Using ng-qrcode library -->
        <qr-code [value]="'' + card.code" [size]="qrWidth" [errorCorrectionLevel]="'M'" />
      </div>
      <div class="card-info">
        <div class="person-name">{{ card.person.name }} {{ card.person.surname }}</div>
        @if (card.children && card.children.length > 0) {
          <div class="children-info">
              @for (child of card.children; track child) {
                <div>{{ child.name }} {{ child.surname }}</div>
              }
          </div>
        }
        <div class="card-valid">Ważna do: <strong>{{ card.valid | date: 'yyyy-MM-dd' }}</strong></div>
        <div class="card-number">Numer karty: <strong>{{ card.nr }}</strong></div>
      </div>
    </div>
  } @else {
    <div class="no-card-container">
      <div class="no-card-icon">
        <mat-icon>credit_card</mat-icon>
      </div>
      <h2 class="no-card-title">Brak karty partnerskiej</h2>
      <p class="no-card-description">
        Nie masz jeszcze aktywnej karty w programie partnerskim Zgrane Grono.
      </p>
      <div class="steps-container">
        <h3 class="steps-title">Jak uzyskać kartę?</h3>
        <div class="steps-list">
          <div class="step-item">
            <div class="step-number">1</div>
            <div class="step-content">
              <h4>Załóż konto</h4>
              <p>Wypełnij formularz podając email i hasło</p>
            </div>
          </div>
          <div class="step-item">
            <div class="step-number">2</div>
            <div class="step-content">
              <h4>Zweryfikuj email</h4>
              <p>Odbierz link weryfikacyjny na podany adres email</p>
            </div>
          </div>
          <div class="step-item">
            <div class="step-number">3</div>
            <div class="step-content">
              <h4>Zaloguj się do panelu</h4>
              <p>Zaloguj się do panelu użytkownika i wypełnij dane mieszkańca</p>
            </div>
          </div>
          <div class="step-item">
            <div class="step-number">4</div>
            <div class="step-content">
              <h4>Zamów kartę</h4>
              <p>Przejdź do sekcji z kartą mieszkańca i złóż tam  na kartę dla wpisanej osoby</p>
            </div>
          </div>
        </div>
      </div>
      <div class="action-buttons">
        <button mat-raised-button color="primary" routerLink="/kontakt">
          <mat-icon>email</mat-icon>
          Skontaktuj się z nami
        </button>
      </div>
    </div>
  }
</div>